export const SEO = {
  title: "Mateus Neres - Backend Developer - Java, Spring, AWS, Kafka",
  url: "https://mateusneres.dev",
  description:
    "I am a backend developer. I have extensive experience both as a freelancer and as a team member, working with various languages and frameworks. However, my primary focus in recent times has been on the Java ecosystem, particularly using the Spring Framework, Cloud, Messaging, and other related technologies.",
  siteName: "mateusneres.dev",
  github: "https://github.com/mateusneresrb",
  avatar: "https://avatars.githubusercontent.com/u/52140952",
  author: "Mateus Neres",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "https://mateusneres.dev",
    site_name: "mateusneres.dev",
    title: "Mateus Neres",
    description:
      "Lets make things better with quality code - Learn Backend Development / API's / Automations / Serverless / Architecture / and more.",
    images: [
      {
        url: "https://mateusneres.dev/images/sharing-image.jpg",
        alt: "Mateus Neres - Software Engineer - Java, Spring Framework, Kafka, AWS",
        width: 1200,
        height: 630,
      },
    ],
  },
};
